import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggleeinheit"
export default class extends Controller {
	static targets = ["inputEinheit"]

	connect() {}

	// Toggle Zeichen (HTML) und Value (HiddenField)
	toggle({ currentTarget }) {
		switch (currentTarget.innerHTML) {
			case "%":
				currentTarget.innerHTML = "€"
				this.inputEinheitTarget.value = "nominal"
				break
			case "€":
				currentTarget.innerHTML = "%"
				this.inputEinheitTarget.value = "prozentual"
				break
			case "Monate":
				currentTarget.innerHTML = "Jahre"
				this.inputEinheitTarget.value = "12"
				break
			case "Jahre":
				currentTarget.innerHTML = "Monate"
				this.inputEinheitTarget.value = "1"
				break
			default:
				console.log("Diese Einheit gibt es nicht!")
		}
	}
}
